import { Navigate, useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import EventDetailHeader from '../components/events/EventDetailHeader'
import { EventDetailBody } from '../components/events/EventDetailBody'
import EventRelatedEvents from '../components/events/EventRelatedEvents'
import { getEventBySlug, getRelatedEvents } from '../data/eventsContent'
import { programSectionGap } from '../components/programs/programLayout'
import { mobilePaddingX, mobileSectionPy, mobileTitleToContentGap } from '../theme/mobileLayout'

const sectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export default function EventDetailPage() {
  const { slug } = useParams()
  const event = getEventBySlug(slug)
  const relatedEvents = getRelatedEvents(slug, 2)

  if (!event) {
    return <Navigate to="/events" replace />
  }

  return (
    <Box>
      <Box
        sx={{
          ...sectionWrapperSx,
          pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
          pb: { xs: 6, md: 8, lg: 0 },
        }}
      >
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <EventDetailHeader title={event.title} date={event.detailDate} />

          <Box
            sx={{
              mt: mobileTitleToContentGap,
              width: '100%',
              height: { xs: 240, sm: 400, md: 600, lg: 865 },
              borderRadius: '20px',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={event.heroImage}
              alt={event.title}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
          </Box>

          <Box
            sx={{
              mt: mobileTitleToContentGap,
              maxWidth: 1200,
              mx: 'auto',
            }}
          >
            <EventDetailBody
              intro={event.intro}
              highlights={event.highlights}
              participants={event.participants}
              learningOutcomes={event.learningOutcomes}
              activities={event.activities}
              whyAttend={event.whyAttend}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          ...sectionWrapperSx,
          mt: programSectionGap,
          pb: programSectionGap,
        }}
      >
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <EventRelatedEvents events={relatedEvents} />
        </Box>
      </Box>
    </Box>
  )
}
